export default __webpack_public_path__ + "static/media/close-popup.a7eb4f3f.svg";